module.exports = __webpack_public_path__ + "static/media/sudoGPReight.97d4b2ec.jpg";